export const COMPONENT_NAME = 'BuyItOrMarkAsPurchased'
